<div id="sav" *ngIf="!sended" class="white z-depth-2 p-5 mt-3">
	<h2>Bienvenue sur le service après vente</h2>
	<h4>Si vous avez rencontré un problème avec une commande. Merci d'utiliser le formulaire ci-dessous pour nous contacter.</h4>
	<h4 class="red-text">Le sav est traité et envoyé chaque Vendredi <a [routerLink]="['/pages/cgv']" tabindex="0" class="no-underline text-600 hover:text-900 transition-duration-150 cursor-pointer mt-3 ">(voir CGV)</a></h4>
	<form #mailForm="ngForm" >
		<div class="grid">
			<div class="col-12 flex justify-content-start align-items-center">
				<span style="margin-right: 15px;">Je suis un</span> 
				
				<p-radioButton label="professionnel" type="radio" class="form-check-input" value="pro" name="type" pInputText [(ngModel)]="type">
				</p-radioButton>
				<p-radioButton label="particulier" type="radio" class="form-check-input" value="part" name="type" pInputText [(ngModel)]="type">
				</p-radioButton>

			</div>
			<div class="col-12" >
				<div class="p-float-label" *ngIf="type == 'pro'">
					<input type="text" pInputText class="form-control" id="customerName" [(ngModel)]="mess.customerName" name="lastname" [required]="true"> 
					<label>Raison sociale</label>
				</div>
			</div>
			<div class="md:col-6 col-12">
				<div class="p-float-label">
					<input type="text" pInputText class="form-control" id="lastname" [(ngModel)]="mess.lastname" name="lastname" [required]="true"> 
					<label>Nom *</label>
				</div>
			</div>
			<div class=" md:col-6 col-12  ">
				<div class="p-float-label">
					<input type="text" pInputText class="form-control" id="firstname" [(ngModel)]="mess.firstname" name="firstname" [required]="true"> 
					<label>Prénom *</label>
				</div>
			</div>
			<div class="md:col-6 col-12 ">
				<div class="p-float-label">
					<input type="text" pInputText class="form-control" id="mail" [(ngModel)]="mess.mail" name="mail" [required]="true"> 
					<label>Email *</label>
				</div>
			</div>
			<div class=" md:col-6 col-12 ">
				<div class="p-float-label">
					<input type="text" pInputText class="form-control" id="tel" [(ngModel)]="mess.tel" name="tel" [required]="true"> 
					<label>Tel *</label>
				</div>
			</div>
			<div class="col-12">
				Votre adresse pourra être utilisée pour une livraison éventuelle.
			</div>
			<div class="col-12 ">
				<div class="p-float-label">
					<input type="text" pInputText class="form-control" id="address" [(ngModel)]="mess.address" name="address" [required]="true"> 
					<label>Adresse *</label>
				</div>
			</div>
			
			<div class="col-6 md:col-4 ">
				<div class="p-float-label">
					<input type="text" pInputText class="form-control" id="cp" [(ngModel)]="mess.cp" name="cp" [required]="true"> 
					<label>Code Postal *</label>
				</div>
			</div>
			<div class="col-6 md:col-4">
				<div class="p-float-label">
					<input type="text" pInputText class="form-control" id="city" [(ngModel)]="mess.city" name="city" [required]="true"> 
					<label>Ville *</label>
				</div>
			</div>

			<div class="md:col-4 col-12">
				<div class="p-float-label">
					<input type="text" pInputText class="form-control" id="country" [(ngModel)]="mess.country" name="country" [required]="true"> 
					<label>Pays *</label>
				</div>
			</div>

			<div class="col-12">
				Jeu concerné par ma demande <i>(Merci d'effectuer une demande par jeu)</i> : 
			</div>
			<div class="col-12 row">
				<div class="md:col-6 col-12 "  *ngIf="editors && editors.length > 0">
					<p-dropdown [required]="true" [options]="editors" [(ngModel)]="mess.editor" name="editor" placeholder="Éditeur du jeu *" (onChange)="filterGames()"></p-dropdown>
				</div>
				<div class="md:col-6 col-12 " *ngIf="games && games.length > 0">
					<p-dropdown [required]="true" [options]="games" [(ngModel)]="mess.game" name="game" placeholder="Choisir un jeu *"></p-dropdown>
				</div>
			</div>
			<div class="col-12 mt-3">
				<div class="p-float-label">
					<textarea [rows]="8" [(ngModel)]="mess.message" name="message" [required]="true" pInputTextarea class="form-control" id="message"  class="w-full form-control md-textarea"></textarea>
					<label form="message">Merci de détailler au mieux votre demande pour que celle-ci soit traitée dans les meilleurs délais *</label>
				</div>
			</div>
			<div class="col-12">
				<label for="files" class="block">Joindre un fichier </label>
				<input type="file" *ngIf="!fileLoading" (change)="onUploadOutput($event)" accept="image/png, image/gif, image/jpeg, image/jpg" pInputText class="form-control border-0" id="files" name="files" browse="Joinde un fichier"> 
				<!-- <mdb-spinner spinnerColor="blue" *ngIf="fileLoading"></mdb-spinner> -->
				<img class="float-right" src="https://blackrockgames.fr/upload/sav/350_{{mess.file}}" *ngIf="mess.file">
				<div>{{this.fileError}}</div>
			</div>
			<div class="col-12 flex justify-content-start align-items-center">
				<button  pButton color="black" outline="true" rounded="true" block="true" class="z-depth-0 my-4 waves-effect mr-2" mdbWavesEffect type="button" (click)="send()" label="{{'Send mail' | translate}}" [disabled]="mailForm.form.invalid"></button>
				<span class="imposed">* champs obligatoires</span>
			</div>

			<div class="col-12">
				<small>
					Les données personnelles collectées ci-dessus sont traitées par Blackrock Games et ses sous-traitants, afin de répondre à votre demande. Elles seront supprimées au plus tard un (1) an à compter de la réception de votre demande. Elles sont hébergées au sein de l’Union européenne et, lorsqu’elles sont susceptibles d’être transférées hors de l'Union Européenne, Blackrock Games s’assure que le traitement soit effectué en conformité avec la réglementation applicable. Vous pouvez demander l’accès, la rectification, la suppression et la portabilité de vos données personnelles ainsi que la limitation de leur traitement et définir des directives post mortem les concernant via le présent formulaire. Pour plus d’informations, veuillez consulter <a href='http://localhost:4200/pages/politique-de-confidentialite'>la charte données personnelles</a>
				</small>
			</div>
		</div>
	</form>
</div>

<div id="sav" *ngIf="sended">
	<h4>Votre message a bien été envoyé.<br/>Nous traitons votre demande et vous serez contacté trés prochainement.</h4>
	<h4 class="red-text">Le sav est traité et envoyé chaque Vendredi</h4>

	<button pButton color="black" outline="true" rounded="true" block="true" class="z-depth-0 my-4 waves-effect" mdbWavesEffect type="button" (click)="sended = false;">
		Effectuer une autre demande
	</button>
</div>